<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("stock_on_hand_by_warehouse")}}</h4>
                <p class="text-subtitle-1">{{$t("list_of_available_items_in_warehouse")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row align="center" class="my-2">
            <!-- <v-col>
                <v-autocomplete
                    label="Warehouse"
                    item-text="display_name"
                    item-value="id"
                    :items="warehouses"
                    v-model="form.warehouse_id"
                    hide-details
                    @update:search-input="searchWarehouses"
                    outlined
                    dense>
                </v-autocomplete>
            </v-col> -->
            <v-col cols="12" md="3">
                <DatePicker
                    label="As Of"
                    outlined
                    dense
                    v-model="form.end_at"
                    hide-details/>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="fetchData" :loading="loading">
                    <v-icon left>mdi-magnify</v-icon>
                    {{$t("search")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-text-field
                    :label="$t('item')"
                    filled
                    single-line
                    dense
                    hide-details="auto"
                    v-model="filter"
                    prepend-inner-icon="mdi-filter"
                    class="me-2">
                </v-text-field>
            </v-col>
            <v-col>
                <v-text-field
                    :label="$t('location')"
                    filled
                    single-line
                    dense
                    hide-details="auto"
                    v-model="filter_location"
                    prepend-inner-icon="mdi-filter"
                    class="me-2">
                </v-text-field>
            </v-col>
            <v-col>
                <v-select
                    :label="$t('availability')"
                    dense
                    filled
                    single-line
                    hide-details
                    :items="availabilityFilterSelect"
                    v-model="filter_availability"
                    ></v-select>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-progress-linear indeterminate v-if="loading"/>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Code</th>
                            <th>Item</th>
                            <th>Location</th>
                            <th>Quantity</th>
                            <th>Unit</th>
                            <th>Min</th>
                            <th>Value</th>
                            <th>Avg. Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in filteredData" :key="index">
                            <td>{{ index + 1}}</td>
                            <td>{{ item.item_code }}</td>
                            <td>{{ item.item_name}}</td>
                            <td>{{ item.location }}</td>
                            <td>
                                <v-icon color="warning" small v-if="item.quantity > item.max">mdi-arrow-up</v-icon>
                                <v-icon color="error" small v-if="item.quantity <= item.min">mdi-arrow-down</v-icon>
                                <v-icon color="success" small v-if="item.quantity > item.min && item.min > 0 && item.quantity <= item.max">mdi-check</v-icon>
                                {{ formatNumber(item.quantity, 2)}}
                            </td>
                            <td>{{ item.unit }}</td>
                            <td>{{ item.min }}</td>
                            <td>{{ formatNumber(item.value, 2) }}</td>
                            <td>{{ formatNumber(item.value / item.quantity, 2) }}</td>
                        </tr>
                    </tbody>
                    <tfoot v-if="data.length > 0">
                        <tr class="font-weight-bold secondary">
                            <td colspan="7">Totals</td>
                            <td>{{formatNumber(getTotal(filteredData, "value"), 2)}}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { formatNumber } from 'accounting';
import { getTotal } from '../../utils/accounting'
import warehouse from './../../services/warehouse/warehouse';
import reports from './../../services/stock/reports';
import moment from 'moment';
import DatePicker from './../../components/common/DatePicker.vue';

export default {
    name: "StockOnHandWarehouseReportView",
    components: {
        DatePicker
    },
    data() {
        return {
            form: {
                warehouse_id: null,
                end_at: moment().format("YYYY-MM-DD")
            },
            warehouses: [],
            data: [],
            loading: false,
            filter: "",
            filter_location: "",
            filter_availability: ""
        }
    },
    computed: {
        filteredData() {
            return this.data.filter((each) => {
                return (
                    (
                        each.item_code.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        each.item_name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
                    ) &&
                    (
                        each.location.toLowerCase().indexOf(this.filter_location.toLowerCase()) > -1
                    ) &&
                    (
                        (this.filter_availability == "shortage" && each.quantity <= each.min && each.min > 0) ||
                        (this.filter_availability == "excess" && each.quantity > each.max) ||
                        (this.filter_availability == "")
                    )
                )
            })
        },
        availabilityFilterSelect() {
            return [
                { text: this.$t("all"), value: "" },
                { text: this.$t("shortage"), value: "shortage" },
                { text: this.$t("excess"), value: "excess" },
            ]
        }
    },
    methods: {
        formatNumber, getTotal,
        searchWarehouses(query) {
            warehouse.search(query).then(response => {
                this.warehouses = Array.from(new Set([...this.warehouses, ...response.data]))
            })
        },
        fetchData() {
            this.data = [];
            this.loading = true;
            reports.getByWarehouseReport(this.form).then(response => {
                this.data = response.data;
            }).finally(() => {
                this.loading = false;
            })
        }
    },
    created() {
        this.form.warehouse_id = this.$route.params.warehouseId;
        this.fetchData();
    }
}
</script>

<style>

</style>